// @martyrs/src/modules/core/locales/index.js
import en from './en.js';
import ru from './ru.js';

export default {
  en,
  ru
};